module.exports = __webpack_public_path__ + "media/images/icons/loupe-d836ac517fb31c796b498665db45ce73.png";